import { render, staticRenderFns } from "./PuzzleNumberSquareEdit.vue?vue&type=template&id=3b78a5f2&"
import script from "./PuzzleNumberSquareEdit.vue?vue&type=script&lang=js&"
export * from "./PuzzleNumberSquareEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports